import { useWatch } from 'react-hook-form'
import { AnswerItem } from '@/components/commons/answer-item'
import { ButtonLegacy } from '@/components/ui/button-legacy'
import { ArrowRightIcon } from '@/components/ui/icons'
import { InputHelpText } from '@/components/ui/input-help-text'
import { Spinner } from '@/components/ui/spinner'
import { useTranslation } from '@/translations/i18n'
import { useChangeStep } from '../hooks/use-change-step'
import { useExperienceShellFormContext } from '../hooks/use-experience-shell-form-context'
import { Category, StepKeyName } from '../types'
import {
	categoryFormatToLabel,
	categoryToCategoryFormats,
	categoryToIcon,
	categoryToLabel
} from '../utils'
import { Content, Fieldset, Footer } from './atoms'

export const ExperienceStep = ({
	experienceId,
	isUpgrade
}: {
	experienceId: number
	isUpgrade: boolean
}) => {
	const { t } = useTranslation()
	const {
		control,
		register,
		formState: { errors }
	} = useExperienceShellFormContext(isUpgrade)
	const categoryWatch = useWatch({
		name: 'experience.categoryKeyName',
		control
	})
	const changeStep = useChangeStep({
		experienceId,
		currentStep: StepKeyName.enum.experience,
		isUpgrade
	})

	return (
		<>
			<Content title={t('experience_shell:step_experience')}>
				<div className='flex flex-col gap-6'>
					<Fieldset title={t('experience_shell:category')}>
						<div className='grid grid-cols-3 gap-4'>
							{Category.options.map((category) => {
								if (
									category === 'generic' ||
									category === 'entertainment'
								) {
									return null
								}
								const Icon = categoryToIcon[category]
								return (
									<AnswerItem
										key={category}
										label={
											<div className='flex flex-col gap-2'>
												<Icon />
												{t(categoryToLabel[category])}
											</div>
										}
										type='radio'
										value={category}
										{...register(
											'experience.categoryKeyName'
										)}
									/>
								)
							})}
						</div>
						{errors.experience?.categoryKeyName && (
							<InputHelpText
								error={t('experience_shell:category_error')}
							/>
						)}
					</Fieldset>
					{!!categoryWatch && categoryWatch !== 'generic' && (
						<Fieldset title={t('experience_shell:format')}>
							<div className='grid grid-cols-3 gap-4'>
								{categoryToCategoryFormats[categoryWatch].map(
									(categoryFormat) => (
										<AnswerItem
											key={categoryFormat}
											label={t(
												categoryFormatToLabel[
													categoryFormat
												]
											)}
											type='radio'
											value={categoryFormat}
											{...register(
												'experience.subCategoryKeyName'
											)}
										/>
									)
								)}
							</div>
							{errors.experience?.subCategoryKeyName && (
								<InputHelpText
									error={t(
										'experience_shell:category_format_error'
									)}
								/>
							)}
						</Fieldset>
					)}
				</div>
			</Content>
			<Footer justify='flex-end'>
				<ButtonLegacy
					disabled={changeStep.isContinueLoading}
					onClick={() =>
						changeStep.handleChangeStep({
							stepToGoTo: StepKeyName.enum.background
						})
					}
					type='button'
				>
					{t('common:continue')}
					{changeStep.isContinueLoading ? (
						<Spinner />
					) : (
						<ArrowRightIcon />
					)}
				</ButtonLegacy>
			</Footer>
		</>
	)
}
